import React from "react";
import ForgotPasswordForm from "../components/ForgotPassword";

export default function ForgotPassword() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <ForgotPasswordForm />
    </div>
  );
}
